import type { AxiosInstance } from 'axios';
import { type Router } from 'vue-router';
import { i18n } from '@/config/i18n.ts';

import { handleError } from './handlers.ts';

function defineInterceptors(axios: AxiosInstance, router: Router) {
  axios.interceptors.request.use((config) => {
    const languageCode = i18n.global.locale.value.split('-')[0] || 'en';

    config.headers = config.headers || {};
    config.headers['Accept-Language'] = languageCode;
    return config;
  });

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    async (error) => {
      const originalConfig = error.config;

      if (error.response) {
        return handleError(axios, router, originalConfig, error);
      }
      return Promise.reject(error);
    },
  );
}

export default defineInterceptors;
